import { render, staticRenderFns } from "./docgencolForm.vue?vue&type=template&id=417e26c2&scoped=true"
import script from "./docgencolForm.vue?vue&type=script&lang=js"
export * from "./docgencolForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e26c2",
  null
  
)

export default component.exports